module.exports = __webpack_public_path__ + "static/media/icon-xml.b7c44155.svg";